module.exports = __webpack_public_path__ + "assets/img/icon-donate-avatar.c28e401b.png";